// SEOComponent.js
import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import { loadKeywords } from '../utils/loadKeywords';

export default function SEOComponent({ title, description, keywords }) {
 return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && keywords.length > 0 && (
        <meta name="keywords" content={keywords.join(', ')} />
      )}
    </Helmet>
  );
}
